import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {IssueType} from "../../domain/entities/issue-type.entity";
import {CommandBus} from "../../services/command-bus.service";
import {CreateIssueTypeCommand} from "../create-issue-type.command";
import {ICommandHandler} from "./i-command.handler";
import {IssueTypeRepository} from "../../domain/repositories/issue-type.repository";
import {takeOverRootFlags} from "../../domain/helpers/issue-type-root.helper";

@CommandHandler(CreateIssueTypeCommand)
@singleton()
export class CreateIssueTypeCommandHandler implements ICommandHandler<IssueType> {

    constructor(
        @inject(CommandBus) private readonly _commandBus: CommandBus,
        @inject(IssueTypeRepository) private readonly _issueTypeRepository: IssueTypeRepository,
    ) {
    }

    /**
     * Sends the create, as the command bus does for a command without a handler; after an accepted
     * create the new type takes over its root's isStatusless, which the backend copied to it. The
     * `entity.created` event that marks the new type persisted is not published here: CommandSendListener
     * publishes it for every Entity payload that is sent, with or without a handler.
     */
    public async handle(command: CreateIssueTypeCommand): Promise<void> {
        const issueType = command.payload;
        if (await this._commandBus.addSendCommand(command)) {
            await takeOverRootFlags(issueType, uid => this._issueTypeRepository.findOneById(uid));
        }
    }

}
